import * as React from 'react'
import cc from 'classcat'
import Image from 'gatsby-image'

import s from './styles.module.css'

export default class Section extends React.Component {
  render() {
    const { title, className, children, background, dark, text, fullBleed, alt = '' } = this.props

    return (
      <section
        className={cc([
          s.section,
          className,
          { [s.hasBgImg]: !!background, [s.dark]: !!dark, [s.fullBleed]: fullBleed }
        ])}
      >
        {background ? (
          <Image
            className={s.backgroundImage}
            outerWrapperClassName={s.backgroundImageWrapper}
            style={{ position: 'absolute' }}
            sizes={background.sizes}
            alt={alt}
          />
        ) : null}
        {title ? <h1 className={s.title}>{title}</h1> : null}
        {text ? <h3 className={s.text}>{text}</h3> : null}
        {children}
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Section/index.js